import { render, staticRenderFns } from "./TaskDeadline.vue?vue&type=template&id=5dd49b98"
import script from "./TaskDeadline.vue?vue&type=script&lang=js"
export * from "./TaskDeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports